module.exports = __webpack_public_path__ + "static/media/blood-min.5ad97657.png";